import React from 'react';

const Alert: React.FC<{
  className?: string;
  type?: 'info' | 'warning' | 'danger' | 'success' | 'primary' | 'secondary' | 'light' | 'dark';
}> = ({ type = 'info', className, children }) => {
  return (
    <div className={`alert alert-${type || 'danger'} ${className || ''}`} role="alert">
      {children}
    </div>
  );
};

export default Alert;
